import { useState, useEffect, useRef } from "react";

export function useAsyncAction(config = {}) {
  const { timeout = 400, onSuccess, onError, validate, ...params } = config;

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const execute = async (action, stopLoadingOnFinal = true) => {
    try {
      setLoading(true);
      const result = await action();

      if (validate) {
        const errorMessage = validate(result);
        if (errorMessage) throw new Error(errorMessage);
      }

      setSuccess(true);
      timeoutRef.current = setTimeout(() => {
        onSuccess?.(result);
        setSuccess(false);
      }, timeout);

      return result;
    } catch (error) {
      onError?.(error);
      throw error;
    } finally {
      if (stopLoadingOnFinal) setLoading(false);
    }
  };

  const reset = () => {
    setLoading(false);
    setSuccess(false);
  };

  return {
    loading,
    success,
    execute,
    reset,
    setSuccess,
    setLoading,
    params,
  };
}
